


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import IDevice from '@/interfaces/device';
import IServerCommand from '@/interfaces/serverCommand';
import { request } from '@/graphql/request';
import GetDevicesServerCommandsQuery from '@/graphql/queries/getDevicesServerCommands.gql';
import CreateServerCommandMutation from '@/graphql/mutations/createServerCommand.gql';

const serverCommandSort = (a: IServerCommand, b: IServerCommand) =>
  +new Date(b.createdAt) - +new Date(a.createdAt);

@Component({})
export default class ServerCommandDisplay extends Vue {
  @Prop({ required: true })
  public device!: IDevice;
  public pendingCommands: IServerCommand[] = [];
  public sentCommands: IServerCommand[] = [];
  public newCommand: string = '';
  public errorMessage: string = '';

  private serverCommands: IServerCommand[] = [];

  public mounted() {
    this.refreshCommandLists();
  }

  public refreshCommandLists() {
    request(GetDevicesServerCommandsQuery as any, { deviceId: this.device.id })
      .then(({ data }) => {
        this.serverCommands = data.getDevicesServerCommands;

        this.pendingCommands = this.serverCommands
          .filter(e => e.status === 'pending')
          .sort(serverCommandSort);

        this.sentCommands = this.serverCommands
          .filter(e => e.status === 'sent')
          .sort(serverCommandSort);
      })
      .catch(error => {
        // TODO: Error handling
        this.errorMessage = 'Getting commands from server failed.';
      });
  }

  public sendNewCommand() {
    const commandText = this.newCommand;
    this.newCommand = '';
    this.errorMessage = '';

    request(CreateServerCommandMutation as any, {
      deviceId: this.device.id,
      commandText,
    })
      .then(({ data, errors }) => {
        if (errors && errors.length && errors.length > 0) {
          throw new Error();
        }
        this.refreshCommandLists();
      })
      .catch(error => {
        this.errorMessage = 'Sending commands to device failed.';
      });
  }
}
